import { render, staticRenderFns } from "./DashboardKpiRow.vue?vue&type=template&id=4b0490ea&scoped=true"
import script from "./DashboardKpiRow.vue?vue&type=script&lang=js"
export * from "./DashboardKpiRow.vue?vue&type=script&lang=js"
import style0 from "./DashboardKpiRow.vue?vue&type=style&index=0&id=4b0490ea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b0490ea",
  null
  
)

export default component.exports